<template>
  <section>
    <form method="post" @submit.prevent="onSend">
      <form-wrapper :validator="$v.form">
        <b-field label="示意圖(各館首頁搜尋下方的廣告區塊)">
          <p class="control">
            <a
              :href="helpImageUrl('各館首頁廣告區塊.png')"
              @click.prevent="
                onClickImage(helpImageUrl('各館首頁廣告區塊.png'))
              "
            >
              <img
                :src="helpImageUrl('各館首頁廣告區塊.png')"
                alt="各館首頁廣告區塊"
                width="256"
              />
            </a>
          </p>
        </b-field>

        <hr />

        <editor
          ref="remark1_editor"
          v-model="form.remark1"
          image-type="Area"
          :area="area.image_path"
        ></editor>

        <b-field>
          <b-button
            :loading="sending"
            type="is-primary"
            native-type="submit"
            :style="{ width: '100%' }"
          >
            {{ $t('attributes.update_data') }}
          </b-button>
        </b-field>
      </form-wrapper>
    </form>

    <b-modal :active.sync="isImageModalActive">
      <p class="image">
        <img :src="selectedImageUrl" alt="" />
      </p>
    </b-modal>
  </section>
</template>

<script>
import { AREA_API } from '@/utils/apis'
import notifyService from '@/services/notifyService'
import Editor from '@/components/editors/Editor4'

export default {
  name: 'AreaRemarkForm',
  components: { Editor },

  props: {
    area: {
      required: true,
      type: Object
    }
  },
  data() {
    return {
      sending: false,

      area_code: this.area.code,
      form: this.extractFormValues(this.area),

      isImageModalActive: false,
      selectedImageUrl: null
    }
  },
  validations: {
    form: {
      remark1: {}
    }
  },
  watch: {
    area(newArea) {
      this.area_code = newArea.code
      this.form = this.extractFormValues(newArea)
    }
  },
  methods: {
    extractFormValues(data) {
      return {
        remark1: data.remark1 || ''
      }
    },
    async onSend() {
      this.form.remark1 = this.$refs.remark1_editor.getData()

      this.$v.$touch()

      if (this.$v.$invalid) {
        return
      }

      const api = `${AREA_API}/${this.area_code}/remark`

      this.sending = true
      try {
        const res = await this.axios.put(api, this.form)

        this.$emit('updated', res.data.data)
        notifyService.success(this.$t('attributes.update_succeed'))
      } catch (e) {
        notifyService.update_error(e)
      } finally {
        this.sending = false
      }
    },
    onClickImage(url) {
      this.isImageModalActive = true
      this.selectedImageUrl = url
    }
  }
}
</script>
